"use client"
import { atom, useAtom } from "jotai"
import { useHydrateAtoms } from "jotai/utils"
import { User } from "@/types/users"
import { EmptyBlog, Blog, Note } from "@types"

import { ScopeProvider } from "jotai-scope"

const userAtom = atom<User>()
const blogAtom = atom<Blog>(EmptyBlog)
const noteAtom = atom<Note>()
const contentsAtom = atom<string>()

/**
 * Functionality used ONLY for the editor components.
 *
 * This does NOT include the publish flow or anything like that;
 * it's just for eg the ShareModal component.
 *
 */
export function useEditorState() {
  const [user] = useAtom(userAtom)
  const [blog] = useAtom(blogAtom)
  const [note] = useAtom(noteAtom)
  const [contents, setContents] = useAtom(contentsAtom)

  console.log("UseEditrState rendered")

  return {
    user,
    blog,
    note,
    contents,
    setContents,
  }
}

function HydrateEditorState({
  children,
  user,
  blog,
  note,
}: {
  children: React.ReactNode
  user: User
  blog: Blog
  note: Note
}) {
  console.log("Hydrating editor state", user, blog, note)
  useHydrateAtoms([
    [userAtom, user],
    [blogAtom, blog],
    [noteAtom, note],
  ])
  return <> {children} </>
}

export function EditorProvider({
  children,
  user,
  blog,
  post,
}: {
  children: React.ReactNode
  user: User
  blog: Blog
  post: Note
}) {
  return (
    <ScopeProvider
      atoms={[userAtom, blogAtom, noteAtom, contentsAtom]}
      key={post.id + blog.id}
    >
      <HydrateEditorState user={user} blog={blog} note={post}>
        {children}
      </HydrateEditorState>
    </ScopeProvider>
  )
}
